import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpRoyaltiesPage() {
  const t = useTranslations('galleries_help.royalties');
  const [openSections, setOpenSections] = useState({
    overview: false,
    whenApply: false,
    split: false,
    whyMatters: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('overview')}
            aria-expanded={openSections.overview}
          >
            <h2>{t('sections.overview.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.overview ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.overview && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.overview.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('whenApply')}
            aria-expanded={openSections.whenApply}
          >
            <h2>{t('sections.when_apply.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.whenApply ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whenApply && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.when_apply.p1')}</p>
              <ul>
                <li>{t('sections.when_apply.list_1')}</li>
                <li>{t('sections.when_apply.list_2')}</li>
              </ul>
              <p>{t('sections.when_apply.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('split')}
            aria-expanded={openSections.split}
          >
            <h2>{t('sections.split.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.split ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.split && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.split.p1')}</p>
              <ul>
                <li>{t('sections.split.list_1')}</li>
                <li>{t('sections.split.list_2')}</li>
                <li>{t('sections.split.list_3')}</li>
              </ul>
              <p>{t('sections.split.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('whyMatters')}
            aria-expanded={openSections.whyMatters}
          >
            <h2>{t('sections.why_matters.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.whyMatters ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whyMatters && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.why_matters.p1')}</p>
              <p>{t('sections.why_matters.p2')}</p>
              <p>{t('sections.why_matters.p3')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
